export const isBigCommerceModelKey = (modelKey: string) => {
  return modelKey.startsWith("DataModel-BigCommerce-");
};

export const BigCommerceStoreKey = "DataModel-BigCommerce-Store";
export const BigCommerceStoreHashKey = "ModelField-DataModel-BigCommerce-Store-storeHash";
export const BigCommerceStoreInstallStateKey = "ModelField-DataModel-BigCommerce-Store-installState";
export const BigCommerceStoreAccessTokenKey = "ModelField-DataModel-BigCommerce-Store-accessToken";
export const BigCommerceStoreScopesKey = "ModelField-DataModel-BigCommerce-Store-scopes";
export const BigCommerceStoreInstalledViaClientIdKey = "ModelField-DataModel-BigCommerce-Store-installedViaClientId";
export const BigCommerceStoreRegisteredWebhooksKey = "ModelField-DataModel-BigCommerce-Store-registeredWebhooks";
export const BigCommerceStoreHashRequiredValidationKey = `Validation-required-ModelField-${BigCommerceStoreKey}-storeHash`;
export const BigCommerceStoreHashUniqueValidationKey = `Validation-unique-ModelField-${BigCommerceStoreKey}-storeHash`;
export const BigCommerceStoreStateRequiredValidationKey = `Validation-required-ModelField-${BigCommerceStoreKey}-state`;
export const BigCommerceStoreInstalledState = `EnumOption-${BigCommerceStoreKey}-state-installed`;
export const BigCommerceStoreUninstalledState = `EnumOption-${BigCommerceStoreKey}-state-uninstalled`;

export const GadgetSessionBigCommerceSIDKey = "Gadget-Session-BigCommerce-SID";
export const GadgetSessionBigCommerceUserIdKey = "Gadget-Session-BigCommerce-UserId";
export const GadgetSessionToBigCommerceStoreKey = "Gadget-Session-Belongs-To-BigCommerce-Store";

export const GadgetSessionBigCommerceSIDUniquenessValidationKey = `Validation-${GadgetSessionBigCommerceSIDKey}-Uniqueness`;

export const BigCommerceAppRoleKey = "Role-BigCommerce-App";
export const BigCommerceAppRoleName = "bigcommerce-app-users";

export const BigCommerceStoreInstallApiIdentifier = "install";
export const BigCommerceStoreReinstallApiIdentifier = "reinstall";
export const BigCommerceStoreUninstallApiIdentifier = "uninstall";
export const BigCommerceStoreRemoveUserApiIdentifier = "removeUser";
